import isEqual from 'lodash/isEqual';

export const useSyncModels = (model1, model2) => {
  watch(model1, (model1Value) => {
    if (isEqual(model1Value, model2.value)) return;
    model2.value = model1Value;
  });
  watch(model2, (model2Value) => {
    if (isEqual(model2Value, model1.value)) return;
    model1.value = model2Value;
  });
};
